
export default function useStyles() {
    return  theme => ({
        paper: {
            position: 'absolute',
            width: 400,
            backgroundColor: theme.palette.background.paper,
            boxShadow: theme.shadows[5],
            padding: 20,
        },
        '@media only screen and (max-width: 600px)': {
            paper: {
                width: '90%',
            },
        },
        buttonCancelar: {
            color: 'gray'
        },
        buttonRemover: {
            color: 'white',
            backgroundColor: '#159B78',
            '&:hover': {
                backgroundColor: 'white',
                color: '#159B78',
                border: '1px solid #159B78'
            },
        },
        tituloModalRemove: {
            marginBottom: '20px'
        }
    });
}